import React from "react";
import Player from "lottie-react";
import spinner from "./animations/wolspinner.json";

const LoadingSpinner = () => (
  <Player autoPlay loop animationData={spinner} assetsPath="/img/lottie/" />
);

export default LoadingSpinner;
